import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// --- IMAGE IMPORTS ---
import bannerImg from '../assets/images/banner.png';

// --- BLOG IMAGE IMPORTS (FROM ASSETS/IMAGES) ---
import securityServicesImg from '../assets/images/security-services.png';
import sectorEventsImg from '../assets/images/sector-events.jpg';
import receptionHeroImg from '../assets/images/reception-security-hero.png';
import monitorAdaptImg from '../assets/images/monitor and adapt.jpg';
import consultAccessImg from '../assets/images/consult & access.jpg';
import designDeployImg from '../assets/images/design & deploy.jpg';
import staticGuardingImg from '../assets/images/static guarding.png';

// --- ACCREDITATION LOGO IMPORTS ---
import acclaimLogo from '../assets/accreditationlogos/Acclaim-accreditation-logo.png';
import acsLogo from '../assets/accreditationlogos/ACS-logo.png';
import armedForcesLogo from '../assets/accreditationlogos/Armed-Forces-Covenant-logo.png';
import bicscLogo from '../assets/accreditationlogos/BICSc-logo.png';
import constructionLineLogo from '../assets/accreditationlogos/Construction-line-gold-member-logo.png';
import disabilityConfidentLogo from '../assets/accreditationlogos/Disability-confident-logo.png';
import investorsInPeopleLogo from '../assets/accreditationlogos/Investors-in-people-logo.png';
import iso9001Logo from '../assets/accreditationlogos/ISO-9001-logo.png';
import iso14001Logo from '../assets/accreditationlogos/ISO-14001-logo.png';
import iso45001Logo from '../assets/accreditationlogos/ISO-45001-logo.png';
import nasduLogo from '../assets/accreditationlogos/NASDU-logo.png';
import risqsLogo from '../assets/accreditationlogos/RISQS-logo.png';
import safeContractorLogo from '../assets/accreditationlogos/Safe-contractor-logo.png';
// pacesetterLogo removed

const News = () => {
  // Pacesetter removed from array
  const accreditationLogos = [
    { src: acclaimLogo, alt: "Acclaim Accreditation" },
    { src: acsLogo, alt: "ACS" },
    { src: armedForcesLogo, alt: "Armed Forces Covenant" },
    { src: bicscLogo, alt: "BICSc" },
    { src: constructionLineLogo, alt: "Construction Line Gold" },
    { src: disabilityConfidentLogo, alt: "Disability Confident" },
    { src: investorsInPeopleLogo, alt: "Investors in People" },
    { src: iso9001Logo, alt: "ISO 9001" },
    { src: iso14001Logo, alt: "ISO 14001" },
    { src: iso45001Logo, alt: "ISO 45001" },
    { src: nasduLogo, alt: "NASDU" },
    { src: risqsLogo, alt: "RISQS" },
    { src: safeContractorLogo, alt: "Safe Contractor" }
  ];

  const [startIndex, setStartIndex] = useState(0);
  const logosToShow = 5; 

  const handleNextLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex + logosToShow) >= accreditationLogos.length ? 0 : prevIndex + logosToShow
    );
  };

  const handlePrevLogos = () => {
    setStartIndex((prevIndex) => 
      (prevIndex - logosToShow) < 0 ? Math.max(0, accreditationLogos.length - logosToShow) : prevIndex - logosToShow
    );
  };

  const visibleLogos = accreditationLogos.slice(startIndex, startIndex + logosToShow);

  return (
    <div className="news-page">
      
      {/* 1. UNIFIED HERO SECTION */}
      <section className="news-hero">
        <style>
          {`
            /* --- REMOVE GLOBAL HERO ARROW JUST FOR THIS PAGE --- */
            .news-hero::after {
              display: none !important;
            }

            /* --- DISABLE HOVER ON STATS CARDS --- */
            .stat-card-no-hover:hover {
              transform: none !important;
              border-bottom-color: var(--color-secondary-light) !important;
              box-shadow: 0 10px 30px rgba(0,0,0,0.05) !important;
            }
            .stat-card-no-hover:hover .stat-label {
              color: var(--color-secondary-grey) !important;
            }
            .stat-card-no-hover:hover::before {
              background-color: var(--color-secondary-light) !important;
              box-shadow: none !important;
            }

            /* Default desktop nowrap */
            .hero-nowrap { white-space: nowrap; }

            /* --- PREMIUM MOBILE RESPONSIVE FIXES --- */
            @media (max-width: 992px) {
              .news-grid { grid-template-columns: repeat(2, 1fr) !important; }
              .services-header-split { grid-template-columns: 1fr !important; gap: 3rem !important; }
              .header-right-col { padding-left: 0 !important; }
            }

            @media (max-width: 768px) {
              /* Hero adjustments to prevent overlap with header */
              .hero-nowrap { white-space: normal; } 
              .news-hero { padding: 13rem 1.5rem 5rem 1.5rem !important; }
              .news-hero h1 { font-size: 2.5rem !important; line-height: 1.2 !important; }
              .news-hero p.subtitle { font-size: 1.1rem !important; }

              /* Enforce global container boundaries */
              .container { padding-left: 1.5rem !important; padding-right: 1.5rem !important; }

              /* Spacing fixes */
              .featured-post-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
              .recent-blogs-section { padding-top: 4rem !important; padding-bottom: 4rem !important; }
              .news-grid { grid-template-columns: 1fr !important; gap: 2rem !important; }
              
              /* Fix CTA layout overlapping screen edges */
              .sleek-cta-banner-override { flex-direction: column !important; text-align: center !important; padding: 3rem 1.5rem !important; }
              .sleek-cta-banner-override > div { min-width: 100% !important; text-align: center !important; }
              .sleek-cta-banner-override p { margin: 0 auto !important; }

              .accreditation-carousel-section { padding: 2rem 0 !important; }
            }
          `}
        </style>
        <div className="container text-center">
          <h1>Security Insights & News</h1>
          <p className="subtitle" style={{ fontSize: 'var(--fs-h3)' }}>
            Expert analysis, industry updates, and operational insights from the Nightmark team.
          </p>
        </div>
      </section>

      {/* 2. FEATURED ARTICLE */}
      <section className="featured-post-section container" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="services-header-split" style={{ alignItems: 'center' }}>
          
          <div className="header-left-col">
            <div 
              className="card-image-box" 
              style={{ 
                backgroundImage: `url("${securityServicesImg}")`, 
                backgroundSize: 'cover', 
                backgroundPosition: 'center', 
                height: '100%', 
                minHeight: '400px', 
                borderRadius: '20px 20px 0 0', 
                marginBottom: '0', 
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
              }}
            >
            </div>
          </div>
          
          <div className="header-right-col" style={{ paddingLeft: '2rem' }}>
            <span style={{ color: 'var(--color-primary-navy)', fontWeight: '700', letterSpacing: '2px', textTransform: 'uppercase', fontSize: 'var(--fs-small)' }}>
              Strategic Insight • 14 Mar 2026
            </span>
            <h2 style={{ marginTop: '1rem', marginBottom: '1.5rem', fontSize: 'var(--fs-h2)' }}>
              Security Is More Than Guards & Gates
            </h2>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Modern security sits at the intersection of people, operations, risk management and organisational resilience. The best providers do not simply protect buildings—they protect operations.
            </p>
            <Link to="/news/security-more-than-guards-and-gates" className="btn btn-primary btn-pill mt-4">
              Read Full Report
            </Link>
          </div>
          
        </div>
      </section>

      {/* 3. MAIN BLOG GRID */}
      <section className="recent-blogs-section bg-light" style={{ paddingTop: '6rem', paddingBottom: '6rem' }}>
        <div className="container blogs-container">
          
          <div className="flush-left" style={{ marginBottom: '4rem', maxWidth: '800px' }}>
            <h2 style={{ fontSize: 'var(--fs-h2)', color: 'var(--color-primary-navy)', marginBottom: '1rem' }}>Latest Publications</h2>
            <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', margin: '0' }}>
              Stay informed on regulatory changes, operational risk strategies, and Nightmark corporate updates.
            </p>
          </div>

          <div className="news-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem' }}>
            
            {/* Article 1 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${sectorEventsImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Corporate Culture</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>Why a Diverse Workforce Makes Security Stronger</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>No matter how advanced technology becomes, effective security still relies on communication, judgement, and cultural awareness.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>10 | MAR | 2026</span>
                  <Link to="/news/why-diverse-workforce-makes-security-stronger" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

            {/* Article 2 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${receptionHeroImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Corporate Culture</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>Why Diversity Strengthens Security</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>Stronger representation creates broader perspectives, better decisions, and ultimately safer environments for the communities we serve.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>05 | MAR | 2026</span>
                  <Link to="/news/why-diversity-strengthens-security" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

            {/* Article 3 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${monitorAdaptImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Operational Excellence</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>Why Operational Intelligence Matters</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>Transforming data into informed decision-making to help organisations move beyond merely reacting to incidents.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>28 | FEB | 2026</span>
                  <Link to="/news/why-operational-intelligence-matters" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

            {/* Article 4 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${consultAccessImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Strategic Insight</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>Why Vested Partnerships Are Changing the Future of FM</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>Moving away from the traditional transactional relationship to create a shared operational objective between both parties.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>20 | FEB | 2026</span>
                  <Link to="/news/vested-partnerships-future-security-fm" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

            {/* Article 5 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${designDeployImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Risk Management</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>How Security Supports Business Continuity</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>Why effective security operations are often one of the first and most important layers of maintaining operational stability.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>12 | FEB | 2026</span>
                  <Link to="/news/how-security-supports-business-continuity" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

            {/* Article 6 */}
            <article className="blog-card-wrapper" style={{ display: 'flex', flexDirection: 'column', height: '100%', borderRadius: '20px', backgroundColor: 'var(--color-white)', overflow: 'hidden' }}>
              <div className="blog-card-image" style={{ backgroundImage: `url("${staticGuardingImg}")`, backgroundSize: 'cover', backgroundPosition: 'center', minHeight: '220px' }}></div>
              <div className="blog-card-text-block text-left" style={{ padding: '2.5rem', display: 'flex', flexDirection: 'column', height: '100%' }}>
                <span className="news-category" style={{ fontSize: 'var(--fs-small)', fontWeight: '700', color: 'var(--color-primary-navy)', textTransform: 'uppercase' }}>Sector Focus</span>
                <h3 style={{ marginTop: '0.5rem', fontSize: 'var(--fs-h3)', color: 'var(--color-primary-dark)' }}>How Threat Intelligence Supports Public Safety</h3>
                <p style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)', color: 'var(--color-secondary-grey)', flexGrow: 1 }}>Gathering and assessing warning signs to improve awareness, preparedness, and public reassurance before risks escalate.</p>
                <div className="blog-card-meta" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1.5rem', borderTop: '1px solid rgba(0,0,0,0.1)', paddingTop: '1.5rem' }}>
                  <span className="blog-date" style={{ fontWeight: '600', fontSize: 'var(--fs-small)', color: 'var(--color-secondary-grey)' }}>05 | FEB | 2026</span>
                  <Link to="/news/how-threat-intelligence-supports-public-safety" className="btn btn-pill" style={{ backgroundColor: 'var(--color-primary-navy)', color: 'var(--color-white)', padding: '0.6rem 1.5rem', fontSize: 'var(--fs-small)', fontWeight: '700' }}>Read Article</Link>
                </div>
              </div>
            </article>

          </div>

          <div className="blog-controls" style={{ marginTop: '4rem' }}>
            <button className="control-btn prev-btn" aria-label="Previous Page">‹</button>
            <span style={{ display: 'flex', alignItems: 'center', fontWeight: '700', color: 'var(--color-primary-navy)', fontSize: 'var(--fs-body)' }}>Page 1 of 4</span>
            <button className="control-btn next-btn" aria-label="Next Page">›</button>
          </div>

        </div>
      </section>

      {/* 4. COMMAND-CENTER STATS SECTION */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-header-text text-center">
            <h2 style={{ fontSize: 'var(--fs-h2)' }}>Security Solutions Built Around People</h2>
            <p className="stats-description" style={{ fontSize: 'var(--fs-body)', lineHeight: 'var(--lh-body)' }}>
              Providing trusted security services that protect what matters most whilst supporting the day-to-day needs of your organisation.
            </p>
          </div>

          <div className="stats-command-grid">
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">ACS</span>
              <span className="stat-number">Approved</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">Helpdesk</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">Strategic</span>
              <span className="stat-number">Consultants</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">24/7</span>
              <span className="stat-number">SOC</span>
            </div>
            
            <div className="stat-card-premium stat-card-no-hover">
              <span className="stat-number">National</span>
              <span className="stat-number">Coverage</span>
            </div>
          </div>
        </div>
      </section>

      {/* 5. SLEEK FLOATING CTA BANNER */}
      <section style={{ backgroundColor: 'var(--color-white)', paddingTop: '4rem', paddingBottom: '6rem' }}>
        <div className="container">
          <div 
            className="sleek-cta-banner-override"
            style={{ 
            backgroundImage: `linear-gradient(to right, rgba(23, 44, 79, 0.95), rgba(23, 44, 79, 0.8)), url(${bannerImg})`,
            borderRadius: '16px',
            padding: '3rem 4rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxShadow: '0 20px 40px rgba(0,0,0,0.15)',
            gap: '2rem',
            flexWrap: 'wrap',
            position: 'relative',
            overflow: 'hidden'
          }}>
            <div style={{ position: 'absolute', top: '-20px', right: '2%', fontSize: '12rem', color: 'var(--color-white)', opacity: '0.03', pointerEvents: 'none', fontWeight: '900', letterSpacing: '-15px' }}>»»</div>

            <div style={{ textAlign: 'left', flex: '1', position: 'relative', zIndex: 2, minWidth: '300px' }}>
              <h2 style={{ color: 'var(--color-white)', marginBottom: '0.5rem', fontSize: '2.1rem', letterSpacing: '-0.5px' }}>Professional Security Management</h2>
              <p style={{ color: 'var(--color-secondary-light)', fontSize: 'var(--fs-body)', margin: 0, maxWidth: '600px', lineHeight: '1.6' }}>
                Discover how our intelligence-led approach can protect your operations.
              </p>
            </div>
            
            <div style={{ position: 'relative', zIndex: 2, flexShrink: 0 }}>
              <Link to="/contact" className="btn btn-pill" style={{ 
                backgroundColor: 'var(--color-white)', 
                color: 'var(--color-primary-navy)', 
                fontWeight: '700', 
                padding: '1rem 2.5rem', 
                fontSize: '0.95rem',
                boxShadow: '0 8px 20px rgba(0,0,0,0.1)'
              }}>
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 6. ACCREDITATION CAROUSEL STRIP */}
      <section className="accreditation-carousel-section" style={{ backgroundColor: 'var(--color-white)', padding: '4rem 0', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
        <div className="container">
          <div className="accreditation-interactive-wrapper" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '2rem' }}>
            
            <button 
              className="control-btn prev-btn" 
              onClick={handlePrevLogos} 
              aria-label="Previous Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ‹
            </button>

            <div className="accreditation-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '2rem', width: '100%', alignItems: 'center', justifyItems: 'center' }}>
              {visibleLogos.map((logo, index) => (
                <div className="accreditation-slide-static" key={index}>
                  <img 
                    src={logo.src} 
                    alt={logo.alt} 
                    style={{ maxHeight: '70px', objectFit: 'contain' }}
                  />
                </div>
              ))}
            </div>

            <button 
              className="control-btn next-btn" 
              onClick={handleNextLogos} 
              aria-label="Next Logos"
              style={{ backgroundColor: 'var(--color-light)', border: 'none', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'var(--color-primary-navy)', fontSize: '1.5rem', fontWeight: 'bold' }}
            >
              ›
            </button>

          </div>
        </div>
      </section>

    </div>
  );
};

export default News;